import { useState, useMemo } from "react";
import Text from "../../Text";
import ProductCard from "../../cards/ProductCard";
import { ROUTE_PATHS } from "../../../../../constants/routeConstants";

const productHref = (slug) =>
  ROUTE_PATHS.PRODUCT_SINGLE.replace(":productSlug", slug);

const chunk = (arr, size) => {
  if (!arr.length || size < 1) return [];
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const ITEMS_PER_COL = 4;
const MAX_COLS = 4;

const ProductsMegaMenu = ({ visible, products = [] }) => {
  const columns = useMemo(() => {
    if (!products.length) return [];
    return chunk(products.slice(0, ITEMS_PER_COL * MAX_COLS), ITEMS_PER_COL);
  }, [products]);
  const [hovered, setHovered] = useState({ img1: null, img2: null });

  const previewImg1 = hovered.img1 ?? products[0]?.images?.[0];
  const previewImg2 = hovered.img2 ?? products[0]?.images?.[1];

  return (
    <div className={visible ? "block" : "hidden"}>
      <div className="max-w-[1440px] mx-auto px-8 py-10 flex gap-8">
        <div className="flex-1 flex flex-col gap-6">
          <div className={["grid gap-8", ["", "grid-cols-1", "grid-cols-2", "grid-cols-3", "grid-cols-4"][columns.length] ?? "grid-cols-4"].join(" ")}>
            {columns.map((col, i) => (
              <div key={i}>
                <ul className="space-y-3">
                  {col.map((item) => (
                    <li key={item.slug}>
                      <Text
                        is="a"
                        href={productHref(item.slug)}
                        className="text-sm text-gray-600 hover:text-blue-500 transition-colors"
                        onMouseEnter={() =>
                          setHovered({
                            img1: item.images?.[0],
                            img2: item.images?.[1],
                          })
                        }
                      >
                        {item.name}
                      </Text>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <Text
            is="a"
            href={ROUTE_PATHS.PRODUCTS}
            className="w-fit text-xs font-semibold text-white bg-blue-500 hover:bg-blue-600 transition-colors px-4 py-2 rounded-full"
          >
            All Products →
          </Text>
        </div>
        {previewImg1 && (
          <div className="flex gap-3 flex-shrink-0">
            {[previewImg1, previewImg2].filter(Boolean).map((img, i) => (
              <div key={i} className="w-[200px]">
                <ProductCard product={{ img, hoverImg: img }} withoutBody />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsMegaMenu;
